module.exports = __webpack_public_path__ + "static/media/slideshow (10).1ec5165a.png";